import { render, staticRenderFns } from "./DataStatisticsDetail.vue?vue&type=template&id=65dfbd83&scoped=true"
import script from "./DataStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./DataStatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./DataStatisticsDetail.vue?vue&type=style&index=0&id=65dfbd83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfbd83",
  null
  
)

export default component.exports